import { useEffect, useState } from "react";
import type { UserContext } from "../../auth/auth";
import { getAgentIdIfPresent } from "../../auth/auth";
import type { SelectedTag } from "../../components/tagSelect/TagSelect";
import type { CustomerStatus } from "../customersApi";

export interface CustomersSearchCriteria {
  readonly query: string;
  readonly statuses: CustomerStatus[];
  readonly travelPayStatus: CustomerStatus | undefined;
  readonly accountManagerIds: string[];
  readonly marketSegment: SelectedTag[];
}

export function defaultCustomerSearchCriteria(userContext: UserContext | null | undefined): CustomersSearchCriteria {
  return {
    query: "",
    statuses: [],
    travelPayStatus: undefined,
    accountManagerIds: [getAgentIdIfPresent(userContext)].filter((id): id is string => !!id),
    marketSegment: [],
  };
}

export const useCustomersSearch = (userContext: UserContext | undefined) => {
  const [customersSearch, setCustomersSearch] = useState<CustomersSearchCriteria>(
    defaultCustomerSearchCriteria(userContext),
  );
  useEffect(() => {
    setCustomersSearch(defaultCustomerSearchCriteria(userContext));
  }, [userContext]);
  return {
    customersSearch,
    setCustomersSearch: (change: Partial<CustomersSearchCriteria>) => setCustomersSearch((s) => ({ ...s, ...change })),
    clear: () => setCustomersSearch(defaultCustomerSearchCriteria(null)),
  };
};
